import React from 'react';
import Card from '../../shared/components/Card';
import CardHeader from '../../shared/components/card-header/CardHeader';
import { I18nUtils } from '../../../i18n/I18nUtils';
import HeaderSearchRefreshFilterOptions from '../../shared/components/HeaderSearchRefreshFilterOptions';
import CardBody from '../../shared/components/CardBody';
import LinkButton from '../../shared/components/LinkButton';
import { PsRoutes } from '../../shared/routing/Routes';
import WorkTable from './WorkTable';
import Row from '../../shared/components/Row';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as workRecentlyAddedActions from '../actions/workRecentlyAddedActions';

class WorkRecentlyAddedCard extends React.Component {

    constructor(props) {
        super(props);
        this.onSearch = this.onSearch.bind(this);
        this.state = { search: '' };
    }

    componentWillMount() {
        this.getWorks();
    }

    getWorks() {
        this.props.worksRecentlyAddedActions.getWorks(this.state.search);
    }

    componentDidUpdate(prevProps, prevState) {
        if ( prevState.search !== this.state.search ) {
            this.getWorks();
        }
    }

    onSearch(search) {
        this.setState({ search: search });
    }

    renderHeaderOptions() {
        return (
            <HeaderSearchRefreshFilterOptions
                onSearch={this.onSearch}
                enableFilter={false}
                enableRefresh={false}
            />
        );
    }

    render() {
        return (
            <Card loading={this.props.loading}>
                <CardHeader title={I18nUtils.tr('TR_RECIEN_ANADIDAS').toUpperCase()}
                            rightOptions={this.renderHeaderOptions()}/>
                <CardBody className={'table-responsive'}>
                    <WorkTable data={this.props.works} error={this.props.worksError}/>
                    <Row clearfix>
                        <div className="col-sm-4 col-sm-offset-8">
                            <LinkButton
                                to={PsRoutes.MY_OUTSOURCES_WORKS}
                                text={I18nUtils.tr('TR_VER_TODAS_LAS_OBRAS').toUpperCase()}
                                className={'btn-lg btn-block'}
                            />
                        </div>
                    </Row>
                </CardBody>
            </Card>
        );
    }

}

const mapStateToProps = state => {
    let errorMessage = state.worksRecentlyAdded.worksError;
    if ( !errorMessage && Object.keys(state.worksRecentlyAdded.works).length === 0 && !state.worksRecentlyAdded.worksLoading ) {
        errorMessage = I18nUtils.tr('TR_NO_EXISTEN_RESULTADOS');
    }
    return ( {
        works: state.worksRecentlyAdded.works,
        loading: state.worksRecentlyAdded.worksLoading,
        worksError: errorMessage,
    } );
};

const mapDispatchToProps = dispatch => ( {
    worksRecentlyAddedActions: bindActionCreators(workRecentlyAddedActions, dispatch),
} );

export default connect(mapStateToProps, mapDispatchToProps)(WorkRecentlyAddedCard);



// WEBPACK FOOTER //
// ./src/app/works/components/WorkRecentlyAddedCard.jsx